export const mensagensLoadingGerador = [
  { texto: 'Cadastrando os novos produtos', textoFinalizado: 'Novos produtos cadastrados!' },
  { texto: 'Gerando os gráficos', textoFinalizado: 'Gráficos foram incluídos!' },
  { texto: 'Incluindo informações da proposta', textoFinalizado: 'Informações da proposta atualizadas!' },
  { texto: 'Ordenando informações e gerando PDF' },
];
